"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const RadioButton = ({ selected = false, onPress, style }) => {
    return (react_1.default.createElement(react_native_1.Pressable, { disabled: true, onPress: onPress, style: react_native_1.StyleSheet.flatten([styles.inactiveRadio, selected && styles.activeRadioBorder, style]) }, selected && react_1.default.createElement(react_native_1.View, { style: styles.activeRadio })));
};
exports.default = RadioButton;
const styles = react_native_1.StyleSheet.create({
    inactiveRadio: {
        borderWidth: 1,
        borderColor: styles_1.Colors.placeholder,
        borderRadius: 31,
        width: 15.5,
        height: 15.5,
        justifyContent: 'center',
        alignItems: 'center',
    },
    activeRadioBorder: {
        borderColor: styles_1.Colors.primary,
        borderWidth: 2,
    },
    activeRadio: {
        width: 7.5,
        height: 7.5,
        borderRadius: 33,
        backgroundColor: styles_1.Colors.primary,
    },
});
